// frontend/src/pages/CorporateLaw.js

import React, { useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaAngleDoubleLeft, FaAngleDoubleRight } from 'react-icons/fa'; // Import icons from react-icons
import '../styles/LawDisplayPage.css';

const CivilLaw = () => {
  const navigate = useNavigate();
  const buttonContainerRef1 = useRef(null);
  const buttonContainerRef2 = useRef(null);

  const scrollLeft = (ref) => {
    ref.current.scrollBy({ left: -300, behavior: 'smooth' });
  };

  const scrollRight = (ref) => {
    ref.current.scrollBy({ left: 300, behavior: 'smooth' });
  };

  return (
    <div className="law-page">
      {/* Heading */}
      <h1>Indian Corporate Law</h1>

      {/* Details of Indian Corporate Law */}
      <div className="content-section">
        <h2>Details of Indian Corporate Law</h2>
        <p>
        Corporate law in India is a body of laws that governs the rights, relations, and conduct of companies, 
        organizations, businesses, and individuals. 
        Some of the important corporate laws in India include:
        </p>
        <p>
          Civil Law comprises a set of rules and regulations that helps in resolving disputes that are 
          non-criminal in nature. The law in India is primarily governed by the Code of Civil Procedure, 
          1908 (CPC), which is a procedural law pertaining to the administration of civil proceedings in India.
        </p>
      </div>

      {/* First Row of Buttons */}
      <div className="button-row">
        <FaAngleDoubleLeft className="scroll-icon left" onClick={() => scrollLeft(buttonContainerRef1)} />
        <div className="button-container" ref={buttonContainerRef1}>
          <button className="big-button">Companies Act, 1956</button>
          <button className="big-button" onClick={() => navigate('/family-law')}>
          Securities and Exchange Board of India Act, 1992
          </button>
          <button className="big-button">Banking Regulation Act, 1949</button>
          {/* <button className="big-button" onClick={() => navigate('/search')}>
            Search area
          </button> */}
        </div>
        <FaAngleDoubleRight className="scroll-icon right" onClick={() => scrollRight(buttonContainerRef1)} />
      </div>

      {/* Second Row of Buttons */}
      <div className="button-row">
        <FaAngleDoubleLeft className="scroll-icon left" onClick={() => scrollLeft(buttonContainerRef2)} />
        <div className="button-container" ref={buttonContainerRef2}>
          <button className="big-button">Insurance Act, 1938</button>
          <button className="big-button">Competition Act, 2002</button>
          <button className="big-button">Indian Electricity Act, 1910</button>
          <button className="big-button" onClick={() => navigate('/search')}>
            Search area
          </button>
        </div>
        <FaAngleDoubleRight className="scroll-icon right" onClick={() => scrollRight(buttonContainerRef2)} />
      </div>
    </div>
  );
};

export default CivilLaw;
